/** Opens Opportunity Manage from the board via the shell inspector. */
import { inject, Injector } from '@angular/core';
import { ActivityEntityName, Opportunity } from '@jms/model';
import { EntityInspectors } from '@workbuddy/ui/v2/blocks/entity.inspector';

/**
 * Must run under the board's `runInInjectionContext` so `EntityInspectors` resolves from the shell
 * route providers — it is NOT providedIn root.
 *
 * Access authorization happens after the inspector shell mounts; the Manage surface owns readonly policy.
 */
export async function navigateToOpportunityRecord(item: Opportunity): Promise<void> {

  if (!item?._id) return;
  const injector = inject(Injector);

  await injector.get(EntityInspectors).open({
    operation: 'edit',
    entity: ActivityEntityName.Opportunity,
    id: item._id,
  });
}
